export default __webpack_public_path__ + "static/media/slider1.f92da521.png";